<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>论文发表时间</th>
			    <th>论文名称</th>
			    <th>发表论文时所在单位</th>
			    <th>发表期刊</th>
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">论文发表时间</div>
		        	{{item.publishTime}}
		        </td>
		        <td>
		        	<div class="label">论文名称</div>
		        	{{item.name}}
		        </td>
		        <td>
		        	<div class="label">发表论文时所在单位</div>
		        	{{item.unit}}
		        </td>
		        <td>
		        	<div class="label">发表期刊</div>
		        	{{item.journal}}
		        </td>
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>论文发表时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.publishTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择论文发表时间">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>论文名称</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.name" name="name" placeholder="请填写论文名称">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>发表论文时所在单位</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.unit" name="unit" placeholder="请填写发表论文时所在单位">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>发表期刊</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.journal" name="journal" placeholder="请填写发表期刊">
				</div>
			</div>

	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { urlHead } from '@/utils/http'
import { 
  dissertationList,
  dissertationAdd,
  dissertationEdit,
  dissertationDelete,
  dissertationQueryById
} from "@/api/tableapi";

export default {
	name: 'tabledissertation',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	publishTime:'',
		    	name:'',
		    	unit:'',
		    	journal:''
		    },
		    popShow:false,

		    xueliOptions:[]
		}
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			dissertationList("").then(res=>{
              if (res.success) {               
                that.formList=res.result.records
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.popData={
		    	publishTime:'',
		    	name:'',
		    	unit:'',
		    	journal:''
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	dissertationQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2

		          if(res.result.publishTime!=''&&res.result.publishTime!=null){
		            let publishTime=res.result.publishTime
		            res.result.publishTime=publishTime.split(" ")[0]
		          }

		          that.popData=res.result
		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    save(){
	    	let that=this

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.publishTime==''||that.popData.publishTime==null) {
		    	that.$message.error('请选择论文发表时间!');
		    	return false
		    }

		    if (that.popData.name==''||that.popData.name==null) {
		    	that.$message.error('请填写论文名称');
		    	return false
		    }

		    if (that.popData.unit==''||that.popData.unit==null) {
		    	that.$message.error('请填写发表论文时所在单位');
		    	return false
		    }

		    if (that.popData.journal==''||that.popData.journal==null) {
		    	that.$message.error('请填写发表期刊');
		    	return false
		    }

		    //通过验证
		    that.popData.publishTime += " 00:00:00"
		    
		    //添加
		    if (that.addOrEdit==1) {
		    	dissertationAdd(that.popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	dissertationEdit(that.popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tabledissertation/index.vue